import { SiteFooter } from "@components/site/SiteFooter"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Year-Round Calendar",
}

export default defineView("template-year-round-calendar", (props) => {
  return (
    <div>
      <ContentBlocks blocks={props.page?.contentBlocks} />
      <SiteFooter />
    </div>
  )
})
